module.exports = __webpack_public_path__ + "img/LOGO_ESTADO_-_AZUL_VAZADO_NOVO.ecd7f522.svg";